import {
  getCompanionFilterOptions,
  getFovFilterList,
} from "../global/utility/Utils";
import { getSortingIcon, getFilterIcon } from "../global/utility/tableUtils";
import React, { useState } from "react";
import { InlineCheckbox } from "../global/utility/styledComponents";
import { TextLink } from "@vds/buttons";
import { CustomTable } from "../global/components/Tables/CustomTable";
import { Body, Title } from "@vds/typography";
import { Tooltip } from "antd";

export const getCompanionTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  GmtToLocal,
  showOptionalCheckbox,
  pageName,
}) => {
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      customStyle: { marginLeft: "10px" },
      filterMode: "tree",
      filteredValue: filteredInfo.name || null,
      isLink: pageName === "DiscoveredCameras" ? false : true,
      hasInfoLink: true,
      navLinks: {
        gatewayInfo: "/companionDeviceInfoPage",
        sensorInfo: "/cameraInfoPage",
        companionDeviceInfo: "/companionDeviceInfoPage",
        cameraInfo: "/cameraInfoPage",
      },
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      onFilter: (value, record) => record.name.includes(value),
      sorter: (a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1),
      sortDirections: ["ascend", "descend", "ascend"],
      showCheckBox: showOptionalCheckbox,
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "state")
        : false,
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      filteredValue: filteredInfo.state || null,
      onFilter: (value, record) => record.state.includes(value),
      sorter: (a, b) =>
        a.state.toLowerCase() < b.state.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Location",
      dataIndex: "uid",
      key: "uid",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "uid", null, getLocation)
        : false,
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      filteredValue: filteredInfo.uid || null,
      onFilter: (value, record) => {
        return getLocation(record.uid, deviceList).includes(value);
      },
      sorter: (a, b) =>
        getLocation(a.uid, deviceList) < getLocation(b.uid, deviceList)
          ? -1
          : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Firmware",
      dataIndex: "version",
      key: "version",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "version")
        : false,
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      sorter: (a, b) =>
        a?.version?.toLowerCase() < b?.version?.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
      filteredValue: filteredInfo.version || null,
      onFilter: (value, record) => record?.version?.includes(value),
    },
    {
      title: "Last Message",
      dataIndex: "lastupdated",
      key: "lastupdated",
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      filteredValue: filteredInfo.lastupdated || null,
      onFilter: (value, record) => record.lastupdated.includes(value),
      sorter: (a, b) =>
        new Date(GmtToLocal(a.lastupdated)) -
        new Date(GmtToLocal(b.lastupdated)),
      sortDirections: ["ascend", "descend", "ascend"],
    },
  ];
};
export const getCamerasTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  GmtToLocal,
  showOptionalCheckbox,
  pageName,
  parentDeviceList,
}) => {
  return [
    {
      title: "Camera",
      dataIndex: "name",
      key: "name",
      filterMode: "tree",
      filteredValue: filteredInfo.name || null,
      isLink: pageName === "DiscoveredCameras" ? false : true,
      hasInfoLink: true,
      customStyle: {
        marginLeft: "10px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "132px",
        display: "block",
        borderBottomStyle: "none",
        overflow: "hidden",
      },
      ellipsis: true,
      navLinks: {
        gatewayInfo: "/companionDeviceInfoPage",
        sensorInfo: "/cameraInfoPage",
        companionDeviceInfo: "/companionDeviceInfoPage",
        cameraInfo: "/cameraInfoPage",
      },
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      sorter: (a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1),
      sortDirections: ["ascend", "descend", "ascend"],
      showCheckBox: showOptionalCheckbox,
    },
    {
      title: "Location",
      dataIndex: "uid",
      key: "uid",
      filters: showTableFilter
        ? createTableFilterList(parentDeviceList, "uid", null, getLocation)
        : false,
      filterMode: "tree",
      filteredValue: filteredInfo.uid || null,
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      onFilter: (value, record) => {
        return getLocation(record.uid, parentDeviceList).includes(value);
      },
      sorter: (a, b) =>
        getLocation(a.uid, parentDeviceList) <
        getLocation(b.uid, parentDeviceList)
          ? -1
          : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },

    {
      title: "Companion",
      dataIndex: "id",
      key: "id",
      filterMode: "tree",
      filteredValue: filteredInfo.id || null,
      filters: showTableFilter ? getCompanionFilterOptions() : false,
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      onFilter: (value, record) => {
        return record.parentdeviceid === value;
      },
      sorter: (a, b) => (a.id.toLowerCase() < b.id.toLowerCase() ? -1 : 1),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      filters: showTableFilter
        ? createTableFilterList(parentDeviceList, "state")
        : false,
      filterMode: "tree",
      filteredValue: filteredInfo.state || null,
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      onFilter: (value, record) => record.state.includes(value),
      sorter: (a, b) =>
        a.state.toLowerCase() < b.state.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Streams",
      width: "200",
      dataIndex: "refid",
      key: "refid",
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      ellipsis: true,
      filterMode: "tree",
      filteredValue: filteredInfo?.refid || null,
      onFilter: (value, record) => {
        return record?.uid === value;
      },
    },
    // {
    //   title: "Apps",
    //   dataIndex: "apps",
    //   key: "apps",
    //   filterMode: "tree",
    //   filteredValue: filteredInfo.image || null,
    //   onFilter: (value, record) => record.image.includes(value),
    //   sortDirections: ["ascend", "descend", "ascend"],
    // },
    {
      title: "Actions",
      dataIndex: "delete",
      key: "delete",
      isDelete: true,
    },
  ];
};

export const getGatewaysDetailsDeviceTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  GmtToLocal,
  pageName,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    customStyle: { width: "20%" },
    filterMode: "tree",
    filteredValue: filteredInfo.name || null,
    isLink: true,
    navLinks: {
      url:
        pageName === "gatewayHealthScoreDetails"
          ? "/sensorHealthScoreDetails"
          : "/sensorInfoPage",
    },
    filters: showTableFilter
      ? createTableFilterList(deviceList, "name")
      : false,
    onFilter: (value, record) => record.name.includes(value),
  },

  {
    title: "Status",
    dataIndex: "state",
    key: "state",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "state")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.state || null,
    onFilter: (value, record) => record.state.includes(value),
  },
  {
    title: "Type",
    dataIndex: "nickname",
    key: "nickname",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "nickname")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.nickname || null,
    onFilter: (value, record) => record?.nickname?.includes(value),
  },
  {
    title: "Last Alert",
    dataIndex: "lastupdated",
    key: "lastupdated",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "lastupdated", "TIME_FILTER")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.lastupdated || null,
    onFilter: (value, record) => GmtToLocal(record.lastupdated).includes(value),
    sorter: (a, b) =>
      new Date(GmtToLocal(a.lastupdated)) - new Date(GmtToLocal(b.lastupdated))
        ? 1
        : -1,
    sortDirections: ["ascend", "descend", "ascend"],
    GmtToLocal: GmtToLocal,
  },
  {
    title: "Signal",
    dataIndex: "id",
    key: "id",
    filterByText: "rssi",
  },
  {
    title: "Battery",
    dataIndex: "id",
    key: "id",
    filterByText: "battery",
  },
];

export const getSensorsDetailDeviceTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  pageName,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    customStyle: { width: "20%" },
    filterMode: "tree",
    filteredValue: filteredInfo.name || null,
    isLink: true,
    navLinks: {
      url:
        pageName === "sensorHealthScoreDetails"
          ? "/gatewayHealthScoreDetails"
          : "/companionDeviceInfoPage",
    },
    filters: showTableFilter
      ? createTableFilterList(deviceList, "name")
      : false,
    onFilter: (value, record) => record.name.includes(value),
    sorter: (a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1),
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Status",
    dataIndex: "state",
    key: "state",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "state")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.state || null,
    onFilter: (value, record) => record.state.includes(value),
    sorter: (a, b) => (a.state.toLowerCase() < b.state.toLowerCase() ? -1 : 1),
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Type",
    dataIndex: "nickname",
    key: "nickname",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "nickname")
      : false,
    filterMode: "tree",
    sorter: (a, b) =>
      a?.nickname?.toLowerCase() < b?.nickname?.toLowerCase() ? -1 : 1,
    sortDirections: ["ascend", "descend", "ascend"],
    filteredValue: filteredInfo.nickname || null,
    onFilter: (value, record) => record?.nickname?.includes(value),
  },
  {
    title: "Location",
    dataIndex: "uid",
    key: "uid",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "uid", null, getLocation)
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.uid || null,
    onFilter: (value, record) => {
      return getLocation(record.uid, deviceList).includes(value);
    },
    sorter: (a, b) =>
      getLocation(a.uid, deviceList) < getLocation(b.uid, deviceList) ? -1 : 1,
    sortDirections: ["ascend", "descend", "ascend"],
  },
];

export const getCompanionDeviceDetailsDeviceTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  GmtToLocal,
  pageName,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    customStyle: { width: "20%" },
    filterMode: "tree",
    filteredValue: filteredInfo.name || null,
    isLink: true,
    navLinks: {
      url:
        pageName === "gatewayHealthScoreDetails"
          ? "/sensorHealthScoreDetails"
          : "/cameraInfoPage",
    },
    filters: showTableFilter
      ? createTableFilterList(deviceList, "name")
      : false,
    onFilter: (value, record) => record.name.includes(value),
  },

  {
    title: "Status",
    dataIndex: "state",
    key: "state",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "state")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.state || null,
    onFilter: (value, record) => record.state.includes(value),
  },
  {
    title: "Type",
    dataIndex: "nickname",
    key: "nickname",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "nickname")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.nickname || null,
    onFilter: (value, record) => record?.nickname?.includes(value),
  },
  {
    title: "Application",
    dataIndex: "application",
    key: "application",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "application", "TIME_FILTER")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.lastupdated || null,
    onFilter: (value, record) => GmtToLocal(record.lastupdated).includes(value),
    sorter: (a, b) =>
      new Date(GmtToLocal(a.lastupdated)) - new Date(GmtToLocal(b.lastupdated))
        ? 1
        : -1,
    sortDirections: ["ascend", "descend", "ascend"],
    GmtToLocal: GmtToLocal,
  },
];

export const getCameraDetailDeviceTableColumns = ({
  showTableFilter,
  filteredInfo,
  incidentList,
  createTableFilterList,
  getLocation,
  pageName,
  GmtToLocal,
}) => [
  {
    title: "Event Type",
    dataIndex: "title",
    key: "title",
    customStyle: { width: "20%" },
    filterMode: "tree",
    filteredValue: filteredInfo.applicationId || null,
    isLink: true,
    navLinks: {
      url:
        pageName === "sensorHealthScoreDetails"
          ? "/gatewayHealthScoreDetails"
          : "/eventsInfo",
    },
    // filters: showTableFilter
    //   ? createTableFilterList(incidentList, "applicationId")
    //   : false,
    // onFilter: (value, record) => record.applicationId?.includes(value),
    //sorter: (a, b) => (a.applicationId?.toLowerCase() < b.applicationId?.toLowerCase() ? -1 : 1),
    sortDirections: ["ascend", "descend", "ascend"],
  },

  {
    title: "Stream",
    dataIndex: "streamName",
    key: "streamName",
    // filters: showTableFilter
    //   ? createTableFilterList(incidentList, "not Available")
    //   : false,
    filterMode: "tree",
    filteredValue: filteredInfo.streamName || null,
    // onFilter: (value, record) => {
    //   console.log("Filtering with value:", value);
    //   console.log("Record id:", record.id);
    //   return record.id && record.id.includes(value);
    // },
    // sorter: (a, b) => (a.id?.toLowerCase() < b.id?.toLowerCase() ? -1 : 1),
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Duration",
    dataIndex: "not Available",
    key: "not Available",
    value: "Not Available",
    // filters: showTableFilter
    //   ? createTableFilterList(incidentList, "nickname")
    //   : false,
    // filterMode: "tree",
    // sorter: (a, b) =>
    //   a?.nickname?.toLowerCase() < b?.nickname?.toLowerCase() ? -1 : 1,
    // sortDirections: ["ascend", "descend", "ascend"],
    // filteredValue: filteredInfo.nickname || null,
    // onFilter: (value, record) => record?.nickname?.includes(value),
  },
  {
    title: "Severity",

    dataIndex: "priority",
    key: "priority",
    sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
    sorter: (a, b) =>
      getLocation(a.priority, incidentList) <
      getLocation(b.priority, incidentList)
        ? -1
        : 1,
    sortDirections: ["ascend", "descend", "ascend"],
  },

  {
    title: "Status",

    dataIndex: "status",
    key: "status",
    sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
    sorter: (a, b) =>
      a.status.toLowerCase() < b.status.toLowerCase() ? -1 : 1,
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Time & Date",

    dataIndex: "createdAt",
    key: "createdAt",
    sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
    sorter: (a, b) =>
      new Date(GmtToLocal(a.createdAt)) - new Date(GmtToLocal(b.createdAt)),
    sortDirections: ["ascend", "descend", "ascend"],
  },
];
export const getDevicesPageTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  GmtToLocal,
  showOptionalCheckbox,
  pageName,
}) => {
  return [
    {
      title: "Device Name",
      dataIndex: "name",
      key: "name",
      customStyle: { marginLeft: "10px" },
      filterMode: "tree",
      filteredValue: filteredInfo.name || null,
      isLink: pageName === "DiscoveredCameras" ? false : true,
      hasInfoLink: true,
      navLinks: {
        gatewayInfo: "/companionDeviceInfoPage",
        sensorInfo: "/cameraInfoPage",
        companionDeviceInfo: "/companionDeviceInfoPage",
        cameraInfo: "/cameraInfoPage",
      },
      filters: showTableFilter
        ? createTableFilterList(deviceList, "name")
        : false,
      onFilter: (value, record) => record.name.includes(value),
      sorter: (a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1),
      sortDirections: ["ascend", "descend", "ascend"],
      showCheckBox: showOptionalCheckbox,
    },
    {
      title: "Created On",
      dataIndex: "createdon",
      key: "createdon",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "createdon", "TIME_FILTER")
        : false,
      filterMode: "tree",
      filteredValue: filteredInfo.createdon || null,
      onFilter: (value, record) => record.createdon.includes(value),
      sorter: (a, b) =>
        new Date(GmtToLocal(a.createdon)) - new Date(GmtToLocal(b.createdon)),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Device Status",
      dataIndex: "state",
      key: "state",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "state")
        : false,
      filterMode: "tree",
      filteredValue: filteredInfo.state || null,
      onFilter: (value, record) => record.state.includes(value),
      sorter: (a, b) =>
        a.state.toLowerCase() < b.state.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Type",
      dataIndex: "nickname",
      key: "nickname",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "nickname")
        : false,
      filterMode: "tree",
      sorter: (a, b) =>
        a?.nickname?.toLowerCase() < b?.nickname?.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
      filteredValue: filteredInfo.nickname || null,
      onFilter: (value, record) => record?.nickname?.includes(value),
    },
    {
      title: "Location",
      dataIndex: "uid",
      key: "uid",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "uid", null, getLocation)
        : false,
      filterMode: "tree",
      filteredValue: filteredInfo.uid || null,
      onFilter: (value, record) => {
        return getLocation(record.uid, deviceList).includes(value);
      },
      sorter: (a, b) =>
        getLocation(a.uid, deviceList) < getLocation(b.uid, deviceList)
          ? -1
          : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
  ];
};

export const getDiscoverCameraTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  GmtToLocal,
  showOptionalCheckbox,
  pageName,
}) => {
  return [
    {
      title: "Camera ID",
      dataIndex: "qrcode",
      key: "qrcode",
      customStyle: { marginLeft: "10px" },
      filterMode: "tree",
      filteredValue: filteredInfo.refid || null,
      isLink: pageName === "DiscoveredCameras" ? false : true,
      hasInfoLink: true,
      navLinks: {
        gatewayInfo: "/companionDeviceInfoPage",
        sensorInfo: "/cameraInfoPage",
        companionDeviceInfo: "/companionDeviceInfoPage",
        cameraInfo: "/cameraInfoPage",
      },
      // filters: showTableFilter
      //   ? createTableFilterList(deviceList, "qrcode")
      //   : false,
      //   filterIcon: () => <Filter
      //   color="#000000"
      //   size="medium"
      // />,
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      onFilter: (value, record) => record.qrcode.includes(value),
      sorter: (a, b) =>
        a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
      showCheckBox: showOptionalCheckbox,
    },

    {
      title: (
        <div style={{ marginRight: 10 }}>
          <strong>Streams</strong>
        </div>
      ),
      //title: "Streams",
      dataIndex: "fov",
      key: "fov",
      // filters: showTableFilter
      //   ? createTableFilterList(deviceList, "qrcode")
      //   : false,
      //   filterIcon: () => <Filter
      //   color="#000000"
      //   size="medium"
      // />,
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      filteredValue: filteredInfo.qrcode || null,
      onFilter: (value, record) => record.qrcode.includes(value),
      sorter: (a, b) =>
        a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      //title: "Stream ID",
      title: (
        <div style={{ marginRight: 10 }}>
          <strong>Stream ID</strong>
        </div>
      ),
      dataIndex: "fov",
      key: "fov",
      // filters: showTableFilter
      //   ? createTableFilterList(deviceList, "qrcode")
      //   : false,
      //   filterIcon: () => <Filter
      //   color="#000000"
      //   size="medium"
      // />,
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filterMode: "tree",
      filteredValue: filteredInfo.qrcode || null,
      onFilter: (value, record) => record.qrcode.includes(value),
      sorter: (a, b) =>
        a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },

    {
      title: "Snapshot",
      dataIndex: "images",
      key: "images",
      isLink: true,
      hasInfoLink: true,
      navLinks: {
        gatewayInfo: "/companionDeviceInfoPage",
        sensorInfo: "/cameraInfoPage",
        companionDeviceInfo: "/companionDeviceInfoPage",
        cameraInfo: "/cameraInfoPage",
      },
    },
    {
      title: "Snapshot On/Off",
      dataIndex: "Toggle",
      key: "Toggle",
      isToggle: true,
    },
  ];
};

export const getAssociateCameraColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  GmtToLocal,
  showOptionalCheckbox,
  pageName,
}) => {
  return [
    {
      title: "Associated Cameras",
      dataIndex: "name",
      key: "name",
      customStyle: { marginLeft: "10px" },
      filterMode: "tree",
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filteredValue: filteredInfo.name || null,
      isLink: pageName === "DiscoveredCameras" ? false : true,
      hasInfoLink: true,
      navLinks: {
        gatewayInfo: "/companionDeviceInfoPage",
        sensorInfo: "/cameraInfoPage",
        companionDeviceInfo: "/companionDeviceInfoPage",
        cameraInfo: "/cameraInfoPage",
      },
      filters: showTableFilter
        ? createTableFilterList(deviceList, "name")
        : false,
      onFilter: (value, record) => record.name.includes(value),
      sorter: (a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1),
      sortDirections: ["ascend", "descend", "ascend"],
      showCheckBox: showOptionalCheckbox,
    },
    {
      title: "Location",
      dataIndex: "uid",
      key: "uid",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "uid", null, getLocation)
        : false,
      filterMode: "tree",
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filteredValue: filteredInfo.uid || null,
      onFilter: (value, record) => {
        return getLocation(record.uid, deviceList).includes(value);
      },
      sorter: (a, b) =>
        getLocation(a.uid, deviceList) < getLocation(b.uid, deviceList)
          ? -1
          : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },

    {
      title: "Status",
      dataIndex: "state",
      key: "state",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "state")
        : false,
      filterMode: "tree",
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filteredValue: filteredInfo.state || null,
      onFilter: (value, record) => record.state.includes(value),
      sorter: (a, b) =>
        a.state.toLowerCase() < b.state.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Fields of Vision",
      dataIndex: "id",
      key: "id",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "name")
        : false,
      filterMode: "tree",
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      filteredValue: filteredInfo.name || null,
      onFilter: (value, record) => record?.name?.includes(value),
      sorter: (a, b) => (a?.id?.toLowerCase() < b?.id?.toLowerCase() ? -1 : 1),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "Apps",
      dataIndex: "nickname",
      key: "nickname",
      filters: showTableFilter
        ? createTableFilterList(deviceList, "nickname")
        : false,
      filterMode: "tree",
      filterIcon: (filtered) => getFilterIcon(filtered),
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      sorter: (a, b) =>
        a?.nickname?.toLowerCase() < b?.nickname?.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
      filteredValue: filteredInfo.nickname || null,
      onFilter: (value, record) => record?.nickname?.includes(value),
    },

    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      isDelete: true,
    },
  ];
};

export const getProvisionedAppColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  pageName,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Timestamp",
    dataIndex: "Timestamp",
    key: "Timestamp",
  },
];

export const getAvailableAppColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  pageName,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Timestamp",
    dataIndex: "Timestamp",
    key: "Timestamp",
  },
];
export const getHealthScorePagesDeviceTableColumns = ({
  showTableFilter,
  filteredInfo,
  deviceList,
  createTableFilterList,
  getLocation,
  pageName,
}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    customStyle: { width: "20%" },
    filterMode: "tree",
    filteredValue: filteredInfo.name || null,
    isLink: true,
    navLinks: {
      url:
        pageName === "sensorsHealthScore"
          ? "/sensorHealthScoreDetails"
          : "/gatewayHealthScoreDetails",
    },
    filters: showTableFilter
      ? createTableFilterList(deviceList, "name")
      : false,
    onFilter: (value, record) => record.name.includes(value),
    sorter: (a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1),
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Device Status",
    dataIndex: "state",
    key: "state",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "state")
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.state || null,
    onFilter: (value, record) => record.state.includes(value),
    sorter: (a, b) => (a.state.toLowerCase() < b.state.toLowerCase() ? -1 : 1),
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Type",
    dataIndex: "nickname",
    key: "nickname",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "nickname")
      : false,
    filterMode: "tree",
    sorter: (a, b) =>
      a?.nickname?.toLowerCase() < b?.nickname?.toLowerCase() ? -1 : 1,
    sortDirections: ["ascend", "descend", "ascend"],
    filteredValue: filteredInfo.nickname || null,
    onFilter: (value, record) => record?.nickname?.includes(value),
  },
  {
    title: "Location",
    dataIndex: "uid",
    key: "uid",
    filters: showTableFilter
      ? createTableFilterList(deviceList, "uid", null, getLocation)
      : false,
    filterMode: "tree",
    filteredValue: filteredInfo.uid || null,
    onFilter: (value, record) => {
      return getLocation(record.uid, deviceList).includes(value);
    },
    sorter: (a, b) =>
      getLocation(a.uid, deviceList) < getLocation(b.uid, deviceList) ? -1 : 1,
    sortDirections: ["ascend", "descend", "ascend"],
  },
  {
    title: "Score",
    dataIndex: "score",
    key: "score",
  },
];

const UnpairedCamerasTable = ({
  data,
  loading,
  onCheckboxChange,
  searchInputText,
}) => {
  const [filteredInfo, setFilteredInfo] = useState([]);
  const [showTableFilter, setShowTableFilter] = useState(true);
  const handleTableChange = (pagination, filters) => {
    setFilteredInfo(filters);
  };
  const handlerFiltedAction = () => {
    setShowTableFilter(!showTableFilter);
    if (showTableFilter) {
      setFilteredInfo([]);
    }
  };

  const columns = [
    {
      title: (
        <Title
          bold={true}
          size="small"
          style={{
            borderBottomStyle: "none",
            textDecoration: "none",
          }}
        >
          Camera ID
        </Title>
      ),
      dataIndex: "qrcode",
      key: "camera_qrcode",
      width: 300,
      ellipsis: true,
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      sorter: (a, b) =>
        a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],

      render: (qrcode, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <InlineCheckbox
            width="auto"
            onChange={(e) => onCheckboxChange(e, record)}
            checked={record.checkboxSelected}
            disabled={record.checkboxDisabled}
          />
          <Tooltip
            placement="bottomLeft"
            autoAdjustOverflow="false"
            title={`camera_${qrcode}`}
          >
            <TextLink
              type="standAlone"
              // onClick={() => navigate(linkUrl, { state })}
              size="large"
              className="link"
              style={{
                borderBottomStyle: "none",
                textDecoration: "none",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                width: "140px",
                display: "block",
                overflow: "hidden",
              }}
            >
              <Body size="large" viewport="desktop" primitive="span">
                camera_{qrcode}
              </Body>
            </TextLink>
          </Tooltip>
        </div>
      ),
    },
    // {
    //   title: (
    //     <Title
    //       bold={true}
    //       size="small"
    //       style={{
    //         borderBottomStyle: "none",
    //         textDecoration: "none"
    //       }}
    //     >
    //       Location
    //     </Title>
    //   ),
    //   dataIndex: 'loc',
    //   // key: 'stream',
    //   // render: (fov) => fov.length,
    //   filterMode: "tree",
    //   filteredValue: filteredInfo.loc || null,
    //   render: () => "N/A",
    //   sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
    //   sorter: (a, b) =>
    //     a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
    //   sortDirections: ["ascend", "descend", "ascend"],
    // },
    {
      title: (
        <Title
          bold={true}
          size="small"
          style={{
            borderBottomStyle: "none",
            textDecoration: "none",
          }}
        >
          Stream
        </Title>
      ),
      dataIndex: "fov",
      key: "stream",
      width: "100",
      render: (fov) => fov?.length || "N/A",
      filterMode: "tree",
      filteredValue: filteredInfo.fov || null,
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      sorter: (a, b) =>
        a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Title
            bold={true}
            size="small"
            style={{
              borderBottomStyle: "none",
              textDecoration: "none",
            }}
          >
            Stream ID
          </Title>
          <div onClick={(e) => handlerFiltedAction()}></div>
        </div>
      ),
      dataIndex: "fov",
      width: 300,
      ellipsis: true,
      key: "streamId",
      sortIcon: ({ sortOrder }) => getSortingIcon(sortOrder),
      sorter: (a, b) =>
        a.qrcode.toLowerCase() < b.qrcode.toLowerCase() ? -1 : 1,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (fov) => {
        if (!fov || fov.length === 0) {
          return "N/A";
        }
        return (
          <>
            {fov.map((stream, index) => {
              return (
                <div
                  key={index}
                  style={{
                    borderBottomStyle: "none",
                    textDecoration: "none",
                    marginLeft: "10px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "132px",
                    display: "block",
                    cursor: "pointer",
                    overflow: "hidden",
                  }}
                >
                  <Tooltip
                    placement="bottomLeft"
                    autoAdjustOverflow="false"
                    title={stream.id}
                  >
                    <span>
                      stream {index + 1} : {stream.id || "N/A"}
                    </span>
                  </Tooltip>
                </div>
              );
            })}
          </>
        );
      },
    },
    {
      title: (
        <Title
          bold={true}
          size="small"
          style={{
            borderBottomStyle: "none",
            textDecoration: "none",
          }}
        >
          Snapshot
        </Title>
      ),
      dataIndex: "fov",
      key: "snapshot",
      render: (fov) => {
        if (
          !fov ||
          fov.length === 0 ||
          fov.some((stream) => !stream.snapshot)
        ) {
          return "N/A";
        }
        return (
          <div style={{ display: "flex" }}>
            {fov.map((stream, index) => (
              <img
                key={index}
                src={`data:image/jpeg;base64,${stream.snapshot}`}
                alt={`Snapshot ${index}`}
                className="camera-snapshot-table"
              />
            ))}
          </div>
        );
      },
    },
  ];
  const customNoDataText = {
    emptyText: (
      <div style={{ color: "black", fontFamily: "Verizon NHG DS" }}>
        <center>
          <br></br>
          <>
            <h3 style={{ fontWeight: "300" }}>No unpaired camera found</h3>
            <p style={{ fontWeight: "400" }}>Try adjusting your search.</p>
          </>
        </center>
      </div>
    ),
  };
  return (
    <div>
      <CustomTable
        width="auto"
        dataList={data}
        columnDetails={columns}
        renderedColumns={columns}
        showTableFilter={showTableFilter}
        searchInputText={searchInputText}
        searchColumns={["qrcode", "fov"]}
        loading={loading}
        pagination={true}
        handleChange={handleTableChange}
        filteredInfo={filteredInfo}
        locale={customNoDataText}
      />
    </div>
  );
};

export default UnpairedCamerasTable;
